import { CustomerSearchTypes } from 'v2/interfaces/reports/interruption';
import * as Yup from 'yup';

export const FilterSchema = Yup.object().shape({
  customer: Yup.string()
    .nullable()
    .when('customer_type', {
      is: CustomerSearchTypes.EMAIL,
      then: Yup.string().email('Campo não é um e-mail válido')
    })
    .when('customer_type', {
      is: CustomerSearchTypes.NAME,
      then: Yup.string().min(5, 'Insira pelo menos 5 caracteres')
    })
});
